<script>
import { mapGetters } from 'vuex'
import { noActivityTimesSpec, noInventorySpec } from '@/rules/product-specs'
import { compareOnlyDateComponents, formatToISODate } from '@aspenware-library/helper-fns'

export default {
  data() {
    return {
      calendarDataHash: '000',
      monthSelected: null,
      yearSelected: null,
    }
  },
  created() {
    this.calendarDataHash = this.generateDataHash()
  },
  mounted() {
    this.monthSelected = this.initialMonth
    this.yearSelected = this.initialYear
  },
  methods: {
    generateDataHash() {
      // This random hash value is used to trigger an refresh of the calendar when data updates
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    },

    /**
     * @param {Date} date
     */
    renderSimpleDate(date, cellType) {
      let classes = ''
      let isDisabled = false
      let html = `<span>${date.getDate()}</span>`
      const dateKey = formatToISODate(date)
      let specClasses = []

      // If the date is before the earliest purchase date, disable it
      if (compareOnlyDateComponents(date, new Date(`${this.earliestPurchaseDate.format('YYYY-MM-DD')}T00:00:00`)) < 0) {
        isDisabled = true
      } else {
        if (
          noActivityTimesSpec.isSatisfiedBy({
            product: this.product,
            date: dateKey,
          }) ||
          noInventorySpec.isSatisfiedBy({
            product: this.product,
            date: dateKey,
          })
        ) {
          specClasses.push('-no-inventory-')
          isDisabled = true
        }
      }

      classes += specClasses.join(' ')

      if (cellType === 'day') {
        return {
          disabled: isDisabled,
          classes: classes,
          html: html,
        }
      }
    },

    updateActivityTimes({ selectedMonth, selectedYear }) {
      this.selectedMonth = selectedMonth || this.initialMonth
      this.selectedYear = selectedYear || this.initialYear

      // Dates for getting the pricing info
      const nextMonth = this.selectedMonth < 12 ? this.selectedMonth + 1 : 1
      const nextMonthYear = this.selectedMonth < 12 ? this.selectedYear : this.selectedYear + 1
      const firstDayDate = new Date(this.selectedYear, this.selectedMonth - 1, 1)
      const lastDayDate = new Date(nextMonthYear, nextMonth - 1, 0)

      const firstDay = {
        year: firstDayDate.getFullYear(),
        month: _.padStart(firstDayDate.getMonth() + 1, 2, '0'),
        day: _.padStart(firstDayDate.getDate(), 2, '0'),
      }

      const lastDay = {
        year: lastDayDate.getFullYear(),
        month: _.padStart(lastDayDate.getMonth() + 1, 2, '0'),
        day: _.padStart(lastDayDate.getDate(), 2, '0'),
      }

      if (this.productHeaderCode) {
        const activityQuery = {
          code: this.product.Activity.Code,
          location: this.product.Activity.Location,
          productHeaderCode: this.productHeaderCode,
          startDate: `${firstDay.year}-${firstDay.month}-${firstDay.day}`,
          endDate: `${lastDay.year}-${lastDay.month}-${lastDay.day}`,
        }
        this.$store.dispatch('activities/getAvailability', activityQuery).then((activityData) => {
          if (!_.isEmpty(activityData.Activities)) {
            let newTimes = activityData.Activities[0].StartTimes
            let currentTimes = this.productActivityTimes
            const combinedTimes = _.assign({}, currentTimes, newTimes)
            this.$store.commit('products/setSelectedProductActivityTimes', combinedTimes)
            this.calendarDataHash = this.generateDataHash()
          }
        })
      }
    },
  },
  watch: {
    productHeaderCode: {
      immediate: true,
      handler(toCode, fromCode) {
        if (this.product.IsActivity && toCode) {
          this.updateActivityTimes({ selectedMonth: this.monthSelected, selectedYear: this.yearSelected })
        }
      },
    },
  },
  computed: {
    initialMonth() {
      return this.initialDate.getMonth() + 1
    },

    initialYear() {
      return this.initialDate.getFullYear()
    },

    productDateAttribute() {
      return !_.isEmpty(this.dateAttributes) ? this.dateAttributes[0] : null
    },

    epd() {
      return this.earliestPurchaseDate?.startOf('day')
    },

    ...mapGetters({
      activityTimes: 'products/selectedProductActivityTimes',
      dateAttributes: 'products/dateAttributes',
      earliestPurchaseDate: 'products/selectedProductEarliestPurchaseDate',
      locale: 'global/locale',
      product: 'products/selectedProduct',
      productHeaderCode: 'products/selectedProductHeaderCode',
      productActivityTimes: 'products/selectedProductActivityTimes',
      timeAtResort: 'global/timeAtResort',
    }),
  },
  props: {
    initialDate: {
      type: Date,
      default: null,
    },
  },
  render() {
    return this.$scopedSlots.default({
      activityDataHash: this.calendarDataHash,
      productDateAttribute: this.productDateAttribute,
      renderSimpleDate: this.renderSimpleDate,
      updateActivityTimes: this.updateActivityTimes,
    })
  },
}
</script>
